/**
 * Version information utility
 * Provides git hash, branch, and build date information
 */

export interface VersionInfo {
  gitHash: string;
  gitBranch: string;
  buildDate: string;
  environment: string;
}

export function getVersionInfo(): VersionInfo {
  return {
    gitHash: import.meta.env.VITE_GIT_HASH || 'unknown',
    gitBranch: import.meta.env.VITE_GIT_BRANCH || 'unknown',
    buildDate: import.meta.env.VITE_BUILD_DATE || 'unknown',
    environment: import.meta.env.VITE_ENVIRONMENT || 'unknown'
  };
}

export function getVersionString(): string {
  const info = getVersionInfo();
  return `${info.environment}-${info.gitHash} (${info.gitBranch})`;
}

export function getBuildInfo(): string {
  const info = getVersionInfo();
  const buildDate = new Date(info.buildDate).toLocaleDateString();
  return `Built: ${buildDate} | ${info.gitHash} | ${info.gitBranch}`;
}

// Debug function to log all environment variables
export function debugEnvironmentVariables(): void {
  console.log('🔍 Environment Variables Debug:');
  console.log('VITE_GIT_HASH:', import.meta.env.VITE_GIT_HASH);
  console.log('VITE_GIT_BRANCH:', import.meta.env.VITE_GIT_BRANCH);
  console.log('VITE_BUILD_DATE:', import.meta.env.VITE_BUILD_DATE);
  console.log('VITE_ENVIRONMENT:', import.meta.env.VITE_ENVIRONMENT);
  console.log('All VITE_ env vars:', Object.keys(import.meta.env).filter(key => key.startsWith('VITE_')));
} 